import React, { useState } from 'react';
import Head from 'next/head';
import NavBar from '../components/Navbar/navbar';

const PrivacyPolicy = () => {
  return (
    <>
      <Head>
        <title>Naitram Privacy Policy</title>
        <link rel="icon" href="/assets/Naitram.png" type="image/png" />
      </Head>
      <style global jsx>{`
  body, html {
    height: 100%;
    margin: 0;
    font-family: Arial, sans-serif;
    background-color: #e6ffe6; /* Light green background */
    color: #333;
  }

  .my-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 100vh; /* Full viewport height */
    padding: 20px;
    width: 100vw;
  }

  h1 {
    color: darkblue;
    margin-bottom: 30px;
  }

  h2 {
    color: navy;
    margin-top: 20px;
    font-size: 26px;
  }

  p {
    font-size: 16px;
  }

  section {
    margin: 20px 0; /* Adds vertical margin only */
    padding: 20px;
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    width: 80%;
    max-width: 800px;
    box-sizing: border-box;
  }
`}</style>

      <NavBar />
      <div className="my-container">
          <section>
              <h2>Introduction</h2>
              <p>Welcome to Naitram, your trusted partner in a digital world. We prioritize your privacy and security, and through this Privacy Policy, we outline our practices aimed at safeguarding your personal information. Naitram collects minimal user information, specifically email, username, and user ID, solely for app functionality and authentication purposes.</p>
          </section>

          <section>
              <h2>Data Collection for Functionality and Authentication</h2>
              <p>At Naitram, we collect only essential information such as your email, username, and user ID. This data is necessary for providing our services and ensuring a secure and personalized experience. We do not collect any other personal information or engage in any form of invasive data harvesting.</p>
          </section>

          <section>
              <h2>No Tracking</h2>
              <p>In today&apos;s digital age, tracking users&apos; online activities is common, but not at Naitram. We guarantee a commitment to privacy that excludes the use of tracking technologies like cookies, web beacons, or tracking pixels, either directly or through third parties. Your activity on our site remains private and anonymous.</p>
          </section>

          <section>
              <h2>Security Measures</h2>
              <p>To fortify your privacy, Naitram employs advanced security measures. Our technological infrastructure is designed to prevent unauthorized access and ensure data integrity. We conduct regular security audits and update our defense systems to address emerging threats and vulnerabilities.</p>
          </section>

          <section>
              <h2>Data Retention and Deletion Policy</h2>
              <p>Naitram retains user information only as long as necessary for the purposes of providing our services and ensuring security. We adhere to strict policies for deleting user information when it is no longer needed or upon user request, ensuring compliance with privacy laws.</p>
          </section>

          <section>
              <h2>Third-Party Services and Partnerships</h2>
              <p>While Naitram engages with third-party services to enhance our offerings, we ensure these partnerships uphold our privacy standards. Our agreements prohibit the collection or sharing of user information, extending our privacy commitments even with external collaborations.</p>
          </section>

          <section>
              <h2>Contact Us</h2>
              <p>If you have any inquiries or need further clarification on our privacy practices, please reach out to us at <a href="mailto:contact@naitram.live" style={{color: "blue"}}>contact@naitram.live</a>. Our support team is ready to assist you with comprehensive responses to ensure your satisfaction and understanding of our privacy policies.</p>
          </section>
      </div>





    </>
  );
};

export default PrivacyPolicy;
